import React, { useEffect, useState } from 'react';
import {
  Col,
  Container,
  Row,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import CountryDropdown from './CountryDropdown';

const FeeType = ({
  item,
  indexValue,
  handleDeleteFeeType,
  setFeeData,
  feeData,
  nameError,
  countryError,
  rateError,
  stateError,
  checkBoxError,
  isPayrix,
  toggleSaveDisabled }) => {
  const [itemFeeType, setItemFeeType] = useState();
  const [itemFormattedFeeRate, setItemFormattedFeeRate] = useState();
  const [itemFeeHammer, setItemFeeHammer] = useState();
  const [itemFeeLiveFee, setItemFeeLiveFee] = useState();
  const [itemFeePremium, setItemFeePremium] = useState();
  const [seed, setSeed] = useState(1);
  const [showFeeAsTaxError, setShowFeeAsTaxError] = useState(false);

  useEffect(() => {
    setItemFeeType(item.feeType);
    setItemFormattedFeeRate(item.feeRate);
    setItemFeeHammer(item.feeHammer);
    setItemFeeLiveFee(item.feeLiveFee);
    setItemFeePremium(item.feePremium);
    setSeed(`fee-${parseFloat(Math.random()).toFixed(3)}`);
  }, [
    item,
    item.feeType,
    item.feeRate,
    item.feeHammer,
    item.feeLiveFee,
    item.feePremium
  ]);

  const inputChangeHandler = (e) => {
    e.persist();
    const { id, checked, value } = e.target;
    const newTaxDataArr = feeData;

    switch (id) {
      case 'feeType':
        newTaxDataArr[indexValue] = { ...feeData[indexValue], [id]: value };
        setItemFeeType(value);
        break;
      case 'feeRate':
        newTaxDataArr[indexValue] = { ...feeData[indexValue], [id]: parseFloat(value).toFixed(3) };
        setItemFormattedFeeRate(parseFloat(value).toFixed(3));
        break;
      case 'feeHammer':
        newTaxDataArr[indexValue] = { ...feeData[indexValue], [id]: checked };
        setItemFeeHammer(checked);
        break;
      case 'feeLiveFee':
        newTaxDataArr[indexValue] = { ...feeData[indexValue], [id]: checked };
        setItemFeeLiveFee(checked);
        break;
      case 'feePremium':
        newTaxDataArr[indexValue] = { ...feeData[indexValue], [id]: checked };
        setItemFeePremium(checked);
        break;
      default:
        break;
    }
    setFeeData(newTaxDataArr);
  };

  const clearInputField = (e) => {
    if (e.currentTarget.value === '0.00') {
      e.currentTarget.value = '';
    }
  };

  const handleRateChange = (e) => {
    const { id, value } = e.target;
    const newTaxDataArr = feeData;
    newTaxDataArr[indexValue] = { ...feeData[indexValue], [id]: value ? parseFloat(value).toFixed(3) : '' };
    setItemFormattedFeeRate(value);
  };

  const dropdownOnchangeHandler = (e, type) => {
    const { value } = e;
    const newTaxDataArr = feeData;

    switch (type) {
      case 'feeCountryID':
        newTaxDataArr[indexValue] = { ...feeData[indexValue], [type]: value };
        break;
      case 'feeStateID':
        newTaxDataArr[indexValue] = { ...feeData[indexValue], [type]: value };
        break;
      default:
        break;
    }
    setFeeData(newTaxDataArr);
  };

  const handleDeleteFee = (e) => {
    e.stopPropagation();
    e.preventDefault();
    handleDeleteFeeType(indexValue);
    const elem = document.getElementById(seed);
    elem.parentElement.removeChild(elem);
  };

  const handleNameKeyUp = (e) => {
    setShowFeeAsTaxError(false);
    toggleSaveDisabled(false);
    const lcValue = e.currentTarget.value.toLowerCase();
    if (lcValue.indexOf('tax') > -1) {
      setShowFeeAsTaxError(true);
      toggleSaveDisabled(true);
    }
  };

  return (

    <Container key={seed} className="mt-4" style={{ paddingLeft: 'unset' }}>
      {showFeeAsTaxError && (
        <div className="alert alert-danger m2-3" role="alert">
          <span className="alert-content">
            <span className="pl-2">
              Taxes cannot be entered in the fees section, please use the taxes section above.
            </span>
          </span>
        </div>
      )}
      <div id={seed} className="mt-4">
        <Row>
          <Col xs={4}>
            <h3>Charge Type: Fee</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <FormGroup className={`${nameError ? 'has-error' : ''}`}>
              <h3>Name</h3>
              <Input
                id="feeType"
                className=""
                maxLength={50}
                name="taxTypeName"
                value={itemFeeType}
                onChange={inputChangeHandler}
                onKeyUp={handleNameKeyUp}
              />
              {nameError
                && (
                  <div
                    className="control-label error-message mt-1"
                    htmlFor="taxTypeName"
                  >
                    Charge type is required
                  </div>
                )}
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup className={`${rateError ? 'has-error' : ''}`}>
              <h3>Rate %</h3>
              <Input
                id="feeRate"
                type="number"
                className=""
                maxLength="50"
                name="feeRate"
                min="0"
                value={itemFormattedFeeRate}
                onChange={handleRateChange}
                onFocus={clearInputField}
              />
              {rateError
                && (
                <div
                  className="control-label error-message mt-1"
                  htmlFor="feeRate"
                >
                  Please enter a valid fee rate %.
                </div>
                )}
            </FormGroup>
          </Col>
          <CountryDropdown
            currentFee={item}
            type="fee"
            dropdownOnchangeHandler={dropdownOnchangeHandler}
            hasCountryError={countryError}
            hasStateError={stateError}
            isPayrix={isPayrix}
          />
        </Row>
        <Row>
          <Col xs={3}>
            <h3>Apply fee type to:</h3>
          </Col>
          <Col xs={2}>
            <FormGroup check>
              <Input
                type="checkbox"
                id="feeHammer"
                name="feeHammer"
                checked={itemFeeHammer}
                onChange={inputChangeHandler}
              />
              <Label check>
                Hammer
              </Label>
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup check>
              <Input
                type="checkbox"
                id="feeLiveFee"
                name="feeLiveFee"
                checked={itemFeeLiveFee}
                onChange={inputChangeHandler}
              />
              <Label check>
                Live Fee
              </Label>
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup check>
              <Input
                type="checkbox"
                id="feePremium"
                name="feePremium"
                checked={itemFeePremium}
                onChange={inputChangeHandler}
              />
              <Label check>
                BP
              </Label>
            </FormGroup>
          </Col>
          <Col xs={12} sm={3}>
            <button
              type="button"
              className="btn btn-link"
              onClick={handleDeleteFee}
            >
              Delete this fee charge
            </button>
          </Col>
        </Row>
        {checkBoxError
          && (
            <div
              className="control-label error-message mt-1"
              htmlFor="taxTypeName"
            >
              Fee Type is Required, Please select at least one Fee Type Check Box
            </div>
          )}
      </div>

    </Container>

  );
};

export default FeeType;
